import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { cerrarSesion } from "../../redux/actions/session"
import { urlapi } from "../../lib/backend/data"
import { Col, Row } from "react-bootstrap"
import GraficoDona from "../facturacion/graficos/dona"
import RegistrosVacios from "../general/registros_vacios"
import { stringByTitleCost } from "../../lib/helpers/data/facturacion/main"

const GraficosCostos = (props) => {
    const {
        condicion_default
    } = props
    const dispatch = useDispatch()
    const [ loading, setLoading ] = useState(false)
    const [ datos, setDatos ] = useState([])
    const [ condicion, setCondicion ] = useState(condicion_default ? condicion_default : {})
    const session = useSelector(state => state.miusuario)
    const token = session.tokenSession

    useEffect(() => {
        const cond = condicion_default ? condicion_default : condicion
        consultarDatos(cond)
    }, [ condicion_default ])

    const consultarDatos = async (forzar_condicion) => {
        const enviar_condicion = forzar_condicion ? forzar_condicion : condicion
        setLoading(true)
        return fetch(`${urlapi}/costos/graph`,{
            method:'POST',
            body: JSON.stringify({
                condicion: enviar_condicion
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(Array.isArray(res) !== false){
                setDatos(res)
            }
            return setLoading(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }

    if(datos.length < 1) return false

    return <div>

    <Row>
    <Col md={12} className='mb-3'>
                    <h4>Segmentación de costos</h4>
                    <Row>
                        <Col md={4}>
                        <span className='d-block mb-3' style={{ fontSize: 11 }}>Costos segmentados</span>
                        <GraficoDona datos={datos} />
                        </Col>
                        {
                            datos.map(tipo => {
                                return  <Col xs={4}>
                                        <span className='d-block mb-3' style={{ fontSize: 11 }}>{stringByTitleCost(tipo.titulo)}</span>
                                        <GraficoDona datos={tipo.subtipos} />
                                    </Col>
                            })
                        }
                        </Row>
                </Col>
    </Row>
    </div>

}

export default GraficosCostos